import axios, { isAxiosError } from 'axios';
import { HEADERS } from '@sravni/koa-utils/lib/constants/headers';
import { getSilentSignInUrl, getSilentSignInVerifyUrl } from '@sravni/utils/lib/auth';
import { BadRequestError } from '@sravni/utils/lib/errors/network';
import { createNetworkError } from './errorFabric.js';

class HttpClient {
    static _instance = (() => {
        const instance = axios.create({
            timeout: 5000,
            responseType: 'json',
            withCredentials: true,
            headers: {
                // eslint-disable-next-line @typescript-eslint/naming-convention
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
        });
        instance.interceptors.response.use((_) => _, (error) => {
            if (isAxiosError(error)) {
                if (!error.response) {
                    return Promise.reject(createNetworkError(error?.status || 500, { message: error.message }));
                }
                const { status, data } = error.response;
                const { message, error: errorFromServer } = data;
                const retryAfter = error.response.headers?.[HEADERS.RETRY_AFTER] ||
                    error.response.headers?.[HEADERS.RETRY_AFTER.toLowerCase()];
                if (status === 400 && errorFromServer) {
                    return Promise.reject(new BadRequestError({
                        code: errorFromServer.code,
                        target: errorFromServer.target,
                        message: errorFromServer.message,
                        details: errorFromServer.details,
                    }));
                }
                return Promise.reject(createNetworkError(status, { message: message || errorFromServer?.message, meta: { retryAfter } }));
            }
            return Promise.reject(error);
        });
        return instance;
    })();
    static async sendOTPByPhoneNumber(options) {
        const { phone, returnUrl, name, authCodeChannel, source, customer, productName,
        // email
         } = options;
        const url = getSilentSignInUrl();
        return HttpClient._instance.post(url, {
            phone,
            returnUrl,
            name,
            // email,
            authCodeChannel,
            source,
            customer,
            productName,
        });
    }
    static async verifyPhoneNumberByOTP(options) {
        const { phone, code } = options;
        const url = getSilentSignInVerifyUrl();
        return HttpClient._instance.post(url, { phone, code }).then((response) => response.data);
    }
}

export { HttpClient };
//# sourceMappingURL=httpClient.js.map
